import PhoneNumber from 'awesome-phonenumber';
export var phoneNumberToCountryCode = function (countryCode, phoneNumber) {
    return new PhoneNumber("+" + countryCode + phoneNumber).getRegionCode();
};
export var phoneStringToCountryCode = function (phone) {
    var regionCode = new PhoneNumber(phone).getRegionCode();
    return "" + PhoneNumber.getCountryCodeForRegionCode(regionCode);
};
export var phoneNumberIsValid = function (phoneNumber) {
    return new PhoneNumber("+" + phoneNumber.countryCode + phoneNumber.number).isValid();
};
//# sourceMappingURL=index.js.map